/**
 * Represents a pool that manages a set of reusable objects.
 */
export class ObjectPool {
    /**
     * Creates an instance of ObjectPool.
     *
     * @param factory A function used to create a new object when the pool is empty.
     * @param destroy A function used to destroy objects when clearing the pool.
     */
    constructor(factory, destroy) {
        this.pool = [];
        this.factory = factory;
        this.destroy = destroy;
    }
    /**
     * Acquires an object from the pool or creates a new one if the pool is empty.
     *
     * @return {T} An object from the pool or a new one if the pool is empty.
     */
    acquire() {
        if (this.pool.length > 0) {
            return this.pool.pop();
        }
        return this.factory();
    }
    /**
     * Releases an object back into the pool for reuse.
     *
     * @param obj The object to be released into the pool.
     */
    release(obj) {
        this.pool.push(obj);
    }
    /**
     * Destroys all objects in the pool and empties it.
     */
    clear() {
        for (const obj of this.pool) {
            this.destroy(obj);
        }
        this.pool.length = 0;
    }
}
